import { ReactNode } from 'react';
import { Divider, Typography } from '@mui/material';

interface OfferSectionProps {
  title: string;
  dividerTop?: number;
  children: ReactNode;
}

function OfferSection({ title, dividerTop = 2, children }: OfferSectionProps) {
  return (
    <>
      <Divider sx={{ mt: dividerTop, mb: 0.5 }} />
      <Typography variant="body2" fontWeight={700} sx={{ color: 'primary.main', mb: 1.5, mt: 2 }}>
        {title}
      </Typography>
      {children}
    </>
  );
}

export default OfferSection;
